<template>
    <base-tippy
        :content="content"
        placement="left"
        @click.native="$emit('go-to')"
    >
        <base-button-icon
            color-type="secondary"
            icon="edit"
        ></base-button-icon>
    </base-tippy>
</template>

<script>
import BaseTippy from './BaseTippy'
import BaseButtonIcon from './Buttons/BaseButtonIcon'

export default {
  name: 'ResumeTippy',
  components: {
    BaseTippy,
    BaseButtonIcon
  },

  props: {
    content: String
  },

  emits: ['go-to']
}
</script>

<style scoped>

</style>
